document.addEventListener('DOMContentLoaded', () => {
  initTdHeader();
  initTdNavigation();
  initTdDrawers();
  initTdSearch();
  initTdWishlist();
  initTdForms();
  initTdAccordions();
  initTdFaqSearch();
  initTdResources();
  initTdCart();
  initTdShop();
  initTdProduct();
  initTdRecentlyViewed();
  initTdTestimonials();
  initTdHashScroll();
});

function initTdHashScroll() {
  const hash = window.location.hash;
  if (!hash || hash.length < 2) return;

  const target = document.getElementById(decodeURIComponent(hash.slice(1)));
  if (!target) return;

  window.requestAnimationFrame(() => {
    const header = document.querySelector('#header-group') || document.querySelector('.site-header');
    const offset = (header?.getBoundingClientRect().height || 0) + 12;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  });
}

function validateTdField(field) {
  const error = document.querySelector(`[data-error-for="${field.id}"]`);
  let message = '';
  const value = field.value.trim();

  if (field.required && !value) {
    message = field.dataset.requiredMessage || 'Please complete this field.';
  } else if (field.type === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
    message = 'Please enter an email address in the format name@example.com.';
  } else if (field.minLength > 0 && value.length < field.minLength) {
    message = `Please use at least ${field.minLength} characters.`;
  }

  field.setAttribute('aria-invalid', String(Boolean(message)));
  if (error) error.textContent = message;
  return !message;
}

function initTdForms() {
  document.querySelectorAll('[data-validate-form], .signup__form, .contact-form, .footer-newsletter').forEach((form) => {
    if (form.dataset.tdFormBound === 'true') return;
    form.dataset.tdFormBound = 'true';
    form.setAttribute('novalidate', '');

    const fields = [...form.querySelectorAll('input, select, textarea')].filter(
      (field) => field.type !== 'hidden' && field.type !== 'submit'
    );

    fields.forEach((field) => {
      field.addEventListener('blur', () => validateTdField(field));
    });

    form.addEventListener('submit', (event) => {
      const valid = fields.map(validateTdField).every(Boolean);
      const status = form.querySelector('[data-form-status]');

      if (!valid) {
        event.preventDefault();
        if (status) status.hidden = true;
        fields.find((field) => field.getAttribute('aria-invalid') === 'true')?.focus();
      }
    });

    const status = form.querySelector('[data-form-status]:not([hidden])');
    if (status && status.textContent.trim()) {
      status.focus();
    }
  });
}

function initTdAccordions() {
  document.querySelectorAll('.accordion-trigger').forEach((button) => {
    if (button.dataset.tdAccordionBound === 'true') return;
    button.dataset.tdAccordionBound = 'true';

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      button.setAttribute('aria-expanded', String(!expanded));
      if (panel) panel.hidden = expanded;
    });
  });
}

function initTdFaqSearch() {
  const search = document.querySelector('[data-faq-search], #faq-search');
  const items = document.querySelectorAll('[data-faq-item]');
  const groups = document.querySelectorAll('[data-faq-group]');
  const empty = document.querySelector('[data-faq-empty]');
  if (!search || !items.length) return;

  search.addEventListener('input', () => {
    const query = search.value.trim().toLowerCase();
    let matches = 0;

    items.forEach((item) => {
      const visible = !query || item.textContent.toLowerCase().includes(query);
      item.hidden = !visible;
      if (visible) matches += 1;
    });

    groups.forEach((group) => {
      const visibleItems = [...group.querySelectorAll('[data-faq-item]')].some((item) => !item.hidden);
      group.hidden = !visibleItems;
    });

    if (empty) empty.hidden = matches !== 0;
  });
}

function initTdResources() {
  document.querySelectorAll('[data-td-resources]').forEach((root) => {
    if (root.dataset.tdResourcesBound === 'true') return;
    root.dataset.tdResourcesBound = 'true';

    const search = root.querySelector('[data-resource-search]');
    const cards = [...root.querySelectorAll('[data-resource-card]')];
    const filters = [...root.querySelectorAll('[data-resource-filter]')];
    const resultCount = root.querySelector('[data-resource-count]');
    const empty = root.querySelector('[data-resource-empty]');
    if (!cards.length) return;

    let category = 'all';

    const filterResources = () => {
      const query = (search?.value || '').trim().toLowerCase();
      let visible = 0;

      cards.forEach((card) => {
        const categoryMatch = category === 'all' || card.dataset.category === category;
        const searchMatch = !query || card.textContent.toLowerCase().includes(query);
        card.hidden = !(categoryMatch && searchMatch);
        if (!card.hidden) visible += 1;
      });

      if (resultCount) {
        resultCount.textContent = `${visible} ${visible === 1 ? 'resource' : 'resources'}`;
      }
      if (empty) empty.hidden = visible !== 0;
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        category = button.dataset.resourceFilter || 'all';
        filters.forEach((control) => {
          control.setAttribute('aria-pressed', String(control === button));
        });
        filterResources();
      });
    });

    search?.addEventListener('input', filterResources);

    const query = new URLSearchParams(window.location.search).get('q');
    if (query && search) search.value = query;

    filterResources();
  });
}

function tdCartRoot() {
  return window.Shopify?.routes?.root || '/';
}

function tdFormatMoney(cents, format) {
  const value = Number(cents || 0);
  if (typeof window.Shopify?.formatMoney === 'function') {
    return window.Shopify.formatMoney(value, format);
  }

  const amount = (value / 100).toFixed(2);
  if (!format) return `$${amount}`;

  return format
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(value / 100)))
    .replace(/\{\{\s*amount\s*\}\}/g, amount);
}

function tdShowToast(message) {
  let toast = document.querySelector('[data-toast]');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'toast';
    toast.setAttribute('data-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.hidden = true;
    document.body.appendChild(toast);
  }

  toast.textContent = message;
  toast.hidden = false;
  toast.classList.add('show');
  window.clearTimeout(tdShowToast._timer);
  tdShowToast._timer = window.setTimeout(() => {
    toast.classList.remove('show');
    window.setTimeout(() => {
      toast.hidden = true;
    }, 350);
  }, 2800);
}

function initTdCart() {
  const drawer = document.querySelector('[data-td-cart-drawer]');
  if (!drawer) return;

  const itemsContainer = drawer.querySelector('[data-cart-items]');
  const footer = drawer.querySelector('[data-cart-footer]');
  const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  const moneyFormat = drawer.dataset.moneyFormat || window.Shopify?.money_format || '${{amount}}';
  const emptyHeading = drawer.dataset.emptyHeading || 'Your cart is ready when you are.';
  const emptyText = drawer.dataset.emptyText || 'Browse calm, useful resources and thoughtful gifts.';
  const emptyLink = drawer.dataset.emptyLink || `${tdCartRoot()}collections/all`;
  const emptyLinkLabel = drawer.dataset.emptyLinkLabel || 'Explore the shop';
  let busy = false;

  const escapeHtml = (value) =>
    String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const updateCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.classList.toggle('is-empty', count === 0);
    });
    document.querySelectorAll('[data-drawer-open="td-cart-drawer"]').forEach((button) => {
      button.setAttribute('aria-label', count > 0 ? `Open cart (${count})` : 'Open cart');
    });
  };

  const renderCart = (cart) => {
    if (!itemsContainer) return;

    updateCount(cart.item_count || 0);
    if (subtotalEl) subtotalEl.textContent = tdFormatMoney(cart.total_price, moneyFormat);
    if (footer) footer.hidden = !cart.item_count;

    if (!cart.item_count) {
      itemsContainer.innerHTML = `
        <div class="cart-empty">
          <h3>${escapeHtml(emptyHeading)}</h3>
          <p>${escapeHtml(emptyText)}</p>
          <a class="button button--secondary" href="${escapeHtml(emptyLink)}">${escapeHtml(emptyLinkLabel)}</a>
        </div>`;
      return;
    }

    itemsContainer.innerHTML = cart.items
      .map((item, index) => {
        const line = index + 1;
        const image = item.image
          ? `<img src="${escapeHtml(item.image)}" alt="" width="76" height="92" loading="lazy">`
          : '<span class="cart-item__image-placeholder" aria-hidden="true"></span>';
        const variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? `<p>${escapeHtml(item.variant_title)}</p>`
            : '';

        return `
          <article class="cart-item" data-cart-key="${escapeHtml(item.key)}">
            ${image}
            <div>
              <h3>${escapeHtml(item.product_title)}</h3>
              ${variant}
              <div class="qty-control" aria-label="Quantity for ${escapeHtml(item.product_title)}">
                <button type="button" data-cart-quantity="decrease" data-cart-line="${line}" data-cart-key="${escapeHtml(item.key)}" aria-label="Decrease quantity">−</button>
                <output aria-live="polite">${item.quantity}</output>
                <button type="button" data-cart-quantity="increase" data-cart-line="${line}" data-cart-key="${escapeHtml(item.key)}" aria-label="Increase quantity">+</button>
              </div>
              <button class="cart-item__remove" type="button" data-cart-remove data-cart-line="${line}" data-cart-key="${escapeHtml(item.key)}">Remove</button>
            </div>
            <span class="cart-item__price">${tdFormatMoney(item.final_line_price, moneyFormat)}</span>
          </article>`;
      })
      .join('');
  };

  const fetchCart = async () => {
    const response = await fetch(`${tdCartRoot()}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  };

  const refreshCart = async () => {
    try {
      const cart = await fetchCart();
      renderCart(cart);
      return cart;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const openCartDrawer = (trigger) => {
    if (typeof window.tdOpenDrawer === 'function') {
      window.tdOpenDrawer('td-cart-drawer', trigger);
    } else {
      document.querySelector('[data-drawer-open="td-cart-drawer"]')?.click();
    }
  };

  const changeLine = async (key, quantity) => {
    if (busy) return;
    busy = true;
    try {
      const response = await fetch(`${tdCartRoot()}cart/change.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!response.ok) throw new Error('Unable to update cart');
      const cart = await response.json();
      renderCart(cart);
    } catch (error) {
      console.error(error);
      await refreshCart();
    } finally {
      busy = false;
    }
  };

  const addFromForm = async (form, trigger) => {
    if (busy) return;
    busy = true;

    const submitButton = form.querySelector('[type="submit"], .product-card__add, [name="add"]');
    const originalLabel = submitButton?.textContent;
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Adding…';
    }

    try {
      const formData = new FormData(form);
      if (!formData.get('quantity')) formData.set('quantity', '1');

      const response = await fetch(`${tdCartRoot()}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });

      const payload = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(payload.description || payload.message || 'Unable to add to cart');
      }

      const cart = await refreshCart();
      openCartDrawer(trigger || submitButton);

      return cart;
    } catch (error) {
      console.error(error);
      tdShowToast(error.message || 'Unable to add that item right now.');
      return null;
    } finally {
      busy = false;
      if (submitButton) {
        submitButton.disabled = false;
        if (originalLabel) submitButton.textContent = originalLabel;
      }
    }
  };

  drawer.addEventListener('click', async (event) => {
    const qtyButton = event.target.closest('[data-cart-quantity]');
    const removeButton = event.target.closest('[data-cart-remove]');

    if (qtyButton) {
      event.preventDefault();
      const key = qtyButton.dataset.cartKey;
      const item = qtyButton.closest('.cart-item');
      const output = item?.querySelector('output');
      const currentQty = Number(output?.textContent || 1);
      const nextQty = qtyButton.dataset.cartQuantity === 'increase' ? currentQty + 1 : currentQty - 1;
      await changeLine(key, Math.max(0, nextQty));
      return;
    }

    if (removeButton) {
      event.preventDefault();
      await changeLine(removeButton.dataset.cartKey, 0);
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-drawer-open="td-cart-drawer"]')) {
      refreshCart();
    }
  });

  // Product cards / TD forms: AJAX add + open prototype drawer (no cart page redirect).
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('.product-card__form, [data-td-add-to-cart]')) return;

      event.preventDefault();
      event.stopPropagation();
      addFromForm(form, event.submitter || form.querySelector('[type="submit"]'));
    },
    true
  );

  // Product page (Horizon buy buttons): keep TD drawer in sync and open it on add.
  document.addEventListener('cart:update', async (event) => {
    if (event.detail?.data?.didError) return;
    await refreshCart();

    const source = event.detail?.data?.source;
    if (source === 'product-form-component' || source === 'product-form') {
      openCartDrawer();
    }
  });

  window.tdRefreshCart = refreshCart;
  window.tdAddToCartFromForm = addFromForm;
  refreshCart();
}

function initTdWishlist() {
  document.querySelectorAll('[data-wishlist]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const pressed = button.getAttribute('aria-pressed') === 'true';
      button.setAttribute('aria-pressed', String(!pressed));
      const label = button.getAttribute('aria-label') || '';
      if (pressed) {
        button.setAttribute('aria-label', label.replace(/^Remove/, 'Add').replace(/ from /, ' to '));
      } else {
        button.setAttribute('aria-label', label.replace(/^Add/, 'Remove').replace(/ to /, ' from '));
      }
    });
  });
}

function initTdHeader() {
  const header = document.querySelector('[data-td-header], .site-header.td-header');
  const backToTop = document.querySelector('.back-to-top');
  if (!header && !backToTop) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const update = () => {
    if (header) {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    }
    if (backToTop) {
      backToTop.classList.toggle('is-visible', window.scrollY > 700);
    }
  };

  update();
  window.addEventListener('scroll', update, { passive: true });

  backToTop?.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
}

function initTdNavigation() {
  const desktopNav = document.querySelector('.desktop-nav');
  if (desktopNav?.dataset.tdNavBound === 'true') return;
  if (desktopNav) desktopNav.dataset.tdNavBound = 'true';

  const closeDropdown = (item) => {
    const button = item.querySelector('[data-shop-toggle]');
    const dropdown = item.querySelector('[data-shop-dropdown]');
    button?.setAttribute('aria-expanded', 'false');
    if (dropdown) dropdown.hidden = true;
  };

  const closeAllDropdowns = (except) => {
    document.querySelectorAll('.nav-item--dropdown').forEach((item) => {
      if (item !== except) closeDropdown(item);
    });
  };

  document.querySelectorAll('.nav-item--dropdown').forEach((item) => {
    const desktopButton = item.querySelector('[data-shop-toggle]');
    const dropdown = item.querySelector('[data-shop-dropdown]');
    if (!desktopButton || !dropdown) return;

    desktopButton.addEventListener('click', (event) => {
      // Keep the document outside-click listener from immediately closing this open.
      event.stopPropagation();
      const expanded = desktopButton.getAttribute('aria-expanded') === 'true';
      closeAllDropdowns(item);
      desktopButton.setAttribute('aria-expanded', String(!expanded));
      dropdown.hidden = expanded;
    });

    desktopButton.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown') return;
      event.preventDefault();
      closeAllDropdowns(item);
      desktopButton.setAttribute('aria-expanded', 'true');
      dropdown.hidden = false;
      dropdown.querySelector('a')?.focus();
    });

    // Defer focusout close: browsers often report relatedTarget as null on the
    // first click into a dropdown link, which used to hide the menu before navigation.
    item.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!item.contains(document.activeElement)) closeDropdown(item);
      }, 0);
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.nav-item--dropdown')) return;
    closeAllDropdowns();
  });

  document.querySelectorAll('[data-mobile-shop-toggle]').forEach((mobileButton) => {
    if (mobileButton.dataset.tdMobileNavBound === 'true') return;
    mobileButton.dataset.tdMobileNavBound = 'true';

    const menuId = mobileButton.getAttribute('aria-controls');
    const mobileMenu = menuId
      ? document.getElementById(menuId)
      : mobileButton.parentElement?.querySelector('[data-mobile-shop-menu]');
    if (!mobileMenu) return;

    mobileButton.addEventListener('click', (event) => {
      event.stopPropagation();
      const expanded = mobileButton.getAttribute('aria-expanded') === 'true';
      mobileButton.setAttribute('aria-expanded', String(!expanded));
      mobileMenu.hidden = expanded;
    });
  });

  const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
  document.querySelectorAll('.desktop-nav__link, .mobile-nav a').forEach((link) => {
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return;

    // Blog/Journal are in-page shortcuts to Resources — never mark as current.
    const label = (link.textContent || '').trim().toLowerCase();
    if (label === 'blog' || label === 'journal') {
      link.classList.remove('is-current', 'active');
      link.removeAttribute('aria-current');
      return;
    }

    let parsed;
    try {
      parsed = new URL(link.href, window.location.origin);
    } catch {
      return;
    }

    // Hash-only shortcuts to another section of the same page are not "current".
    if (parsed.hash) {
      link.classList.remove('is-current', 'active');
      link.removeAttribute('aria-current');
      return;
    }

    const linkPath = parsed.pathname.replace(/\/$/, '') || '/';
    if (linkPath === currentPath) {
      link.classList.add('is-current', 'active');
      link.setAttribute('aria-current', 'page');
    }
  });
}

function initTdDrawers() {
  const overlay = document.querySelector('[data-drawer-overlay], .drawer-overlay');
  let activeDrawer = null;
  let lastFocus = null;

  const getFocusable = (root) =>
    [...root.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])')]
      .filter((el) => {
        if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') return false;
        const style = window.getComputedStyle(el);
        return style.display !== 'none' && style.visibility !== 'hidden';
      });

  const closeDrawer = () => {
    if (!activeDrawer) return;
    activeDrawer.classList.remove('is-open');
    activeDrawer.setAttribute('aria-hidden', 'true');
    overlay?.classList.remove('is-visible');
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('is-locked');
    lastFocus?.focus();
    activeDrawer = null;
    lastFocus = null;
  };

  const openDrawer = (id, trigger) => {
    const drawer = document.getElementById(id);
    if (!drawer) return;

    if (activeDrawer && activeDrawer !== drawer) closeDrawer();

    lastFocus = trigger || document.activeElement;
    activeDrawer = drawer;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) {
      overlay.hidden = false;
      overlay.classList.add('is-visible');
    }
    document.body.classList.add('is-locked');

    const focusable = getFocusable(drawer);
    window.setTimeout(() => (focusable[0] || drawer).focus(), 120);
  };

  window.tdOpenDrawer = openDrawer;
  window.tdCloseDrawer = closeDrawer;

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-drawer-open]');
    const closeButton = event.target.closest('[data-drawer-close]');

    if (openButton) {
      event.preventDefault();
      openDrawer(openButton.getAttribute('data-drawer-open'), openButton);
    }

    if (closeButton || event.target.matches('[data-drawer-overlay], .drawer-overlay')) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeDrawer) {
      closeDrawer();
      return;
    }

    if (!activeDrawer || event.key !== 'Tab') return;

    const focusable = getFocusable(activeDrawer);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
}

function initTdSearch() {
  const dialog = document.querySelector('[data-td-search], #td-site-search');
  if (!dialog) return;

  const openButtons = document.querySelectorAll('[data-search-open]');
  const closeButtons = dialog.querySelectorAll('[data-search-close]');
  const form = dialog.querySelector('[data-td-search-form], form');
  const input = dialog.querySelector('input[type="search"], input[name="q"]');

  const openSearch = (trigger) => {
    try {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    } catch (error) {
      dialog.setAttribute('open', '');
    }
    window.setTimeout(() => input?.focus(), 50);
  };

  const closeSearch = () => {
    try {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
    } catch (error) {
      dialog.removeAttribute('open');
    }
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      openSearch(button);
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      closeSearch();
    });
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeSearch();
  });

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeSearch();
  });

  form?.addEventListener('submit', (event) => {
    const query = (input?.value || '').trim();
    if (!query) {
      event.preventDefault();
      input?.focus();
      return;
    }

    // Ensure navigation even if the dialog top-layer interferes with native submit
    const action = form.getAttribute('action') || '/search';
    const params = new URLSearchParams(new FormData(form));
    params.set('q', query);
    event.preventDefault();
    closeSearch();
    window.location.assign(`${action}?${params.toString()}`);
  });
}

const TD_RECENT_KEY = 'td-recently-viewed';

function tdGetRecentlyViewed() {
  try {
    const stored = JSON.parse(localStorage.getItem(TD_RECENT_KEY) || '[]');
    return Array.isArray(stored) ? stored.filter((handle) => typeof handle === 'string') : [];
  } catch {
    return [];
  }
}

function tdSaveRecentlyViewed(handle) {
  if (!handle) return;
  const next = [handle, ...tdGetRecentlyViewed().filter((item) => item !== handle)].slice(0, 12);
  try {
    localStorage.setItem(TD_RECENT_KEY, JSON.stringify(next));
  } catch {
    /* ignore quota errors */
  }
}

function initTdRecentlyViewed() {
  const productHandle =
    document.querySelector('[data-td-product-handle]')?.dataset.tdProductHandle ||
    document.querySelector('.product-detail[data-product-handle]')?.dataset.productHandle ||
    window.meta?.product?.handle;

  if (productHandle) tdSaveRecentlyViewed(productHandle);

  document.querySelectorAll('[data-td-recently-viewed]').forEach((section) => {
    const grid = section.querySelector('[data-recently-viewed-grid]');
    const sources = [...section.querySelectorAll('[data-recent-source]')];
    if (!grid || !sources.length) return;

    const maxItems = Number(section.dataset.maxItems || 4);
    const recent = tdGetRecentlyViewed();
    let shown = 0;

    sources.forEach((source) => {
      const matchIndex = recent.indexOf(source.dataset.recentSource);
      if (matchIndex === -1 || shown >= maxItems) {
        source.hidden = true;
        return;
      }
      source.hidden = false;
      source.style.order = String(matchIndex);
      shown += 1;
    });

    section.hidden = shown === 0;
  });
}

function initTdProduct() {
  document.querySelectorAll('[data-td-product]').forEach((root) => {
    if (root.dataset.tdProductBound === 'true') return;
    root.dataset.tdProductBound = 'true';

    const jsonEl = root.querySelector('[data-td-product-json]');
    let productData = null;
    try {
      productData = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    } catch {
      productData = null;
    }

    const mainImage = root.querySelector('[data-gallery-main]');
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    const quantity = root.querySelector('[data-product-quantity]');
    const variantInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-current-price]');
    const compareEl = root.querySelector('[data-compare-price]');
    const addButton = root.querySelector('[data-product-detail-add]');
    const buyButton = root.querySelector('[data-buy-now]');
    const form = root.querySelector('[data-td-add-to-cart]');

    const setMainGalleryImage = (url, alt, srcset) => {
      if (!mainImage || !url) return;
      mainImage.src = url;
      if (srcset) {
        mainImage.srcset = srcset;
      } else {
        mainImage.removeAttribute('srcset');
      }
      if (alt) mainImage.alt = alt;
    };

    const activateThumb = (button) => {
      if (!button?.dataset.galleryImage) return;
      setMainGalleryImage(button.dataset.galleryImage, button.dataset.galleryAlt, button.dataset.gallerySrcset);
      thumbs.forEach((thumb) => thumb.setAttribute('aria-current', String(thumb === button)));
    };

    thumbs.forEach((button) => {
      button.addEventListener('click', () => activateThumb(button));
    });

    root.querySelectorAll('[data-product-qty]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!quantity) return;
        const max = Number(quantity.max || 99);
        const min = Number(quantity.min || 1);
        const delta = button.dataset.productQty === 'increase' ? 1 : -1;
        const next = Math.max(min, Math.min(max, Number(quantity.value || 1) + delta));
        quantity.value = String(next);
      });
    });

    const getSelectedOptions = () => {
      const selected = [];
      root.querySelectorAll('.option-group').forEach((group) => {
        const checked = group.querySelector('input[type="radio"]:checked');
        selected.push(checked ? checked.value : null);
      });
      return selected;
    };

    const findVariant = () => {
      if (!productData?.variants?.length) return null;
      if (productData.variants.length === 1) return productData.variants[0];

      const selected = getSelectedOptions();
      return (
        productData.variants.find((variant) => {
          const values = [variant.option1, variant.option2, variant.option3].filter(
            (value) => value != null && value !== ''
          );
          return values.every((value, index) => value === selected[index]);
        }) || null
      );
    };

    const syncVariantMedia = (variant) => {
      if (!variant?.featured_media_id && !variant?.featured_image) return;
      const mediaThumb = variant.featured_media_id
        ? thumbs.find((thumb) => thumb.dataset.mediaId === String(variant.featured_media_id))
        : null;

      if (mediaThumb) {
        activateThumb(mediaThumb);
        return;
      }

      setMainGalleryImage(variant.featured_image, variant.featured_image_alt);
    };

    const applyVariant = () => {
      const variant = findVariant();
      if (!variant) return;

      if (variantInput) variantInput.value = String(variant.id);

      if (priceEl) {
        priceEl.textContent = tdFormatMoney(variant.price, productData.money_format);
      }

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.hidden = false;
          compareEl.textContent = tdFormatMoney(variant.compare_at_price, productData.money_format);
        } else {
          compareEl.hidden = true;
          compareEl.textContent = '';
        }
      }

      const label = variant.available ? 'Add to Cart' : 'Sold Out';
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = label;
      }
      if (buyButton) {
        buyButton.disabled = !variant.available;
      }

      syncVariantMedia(variant);
    };

    root.querySelectorAll('.option-group input[type="radio"]').forEach((input) => {
      input.addEventListener('change', applyVariant);
    });

    buyButton?.addEventListener('click', async () => {
      if (!form || buyButton.disabled) return;
      applyVariant();

      const formData = new FormData(form);
      if (!formData.get('quantity') && quantity) {
        formData.set('quantity', quantity.value || '1');
      }

      buyButton.disabled = true;
      const original = buyButton.textContent;
      buyButton.textContent = 'Redirecting…';

      try {
        const response = await fetch(`${tdCartRoot()}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(payload.description || payload.message || 'Unable to start checkout');
        }
        window.location.assign(`${tdCartRoot()}checkout`);
      } catch (error) {
        console.error(error);
        tdShowToast(error.message || 'Unable to start checkout right now.');
        buyButton.disabled = false;
        buyButton.textContent = original;
      }
    });

    applyVariant();
  });
}

function initTdShop() {
  const root = document.querySelector('[data-td-shop]');
  if (!root) return;

  const grid = root.querySelector('[data-shop-grid], #shop-product-grid');
  const cards = [...root.querySelectorAll('[data-product-card]')];
  const count = root.querySelector('[data-product-count]');
  const sort = root.querySelector('[data-shop-sort], #shop-sort');
  const loadMore = root.querySelector('[data-load-more]');
  const empty = root.querySelector('[data-shop-empty]');
  const pagination = root.querySelector('[data-shop-pagination]');
  const initialVisible = Number(root.dataset.initialVisible || 8);
  // When Shopify pagination is present, show every card on this page.
  // Load More is for single-page catalogs only — otherwise products look "missing".
  let showAll = Boolean(pagination);

  if (!grid || !cards.length) return;

  const params = new URLSearchParams(window.location.search);
  const typeParam = params.get('type');
  const purposeParam = params.get('purpose');
  const sortParam = params.get('sort');
  const typeMap = {
    digital: 'Digital Resource',
    gift: 'Thoughtful Gift',
    personalized: 'Personalized',
    planning: 'Planning Tool',
  };

  const setFilterChecked = (name, value, checked = true) => {
    document.querySelectorAll(`[data-filter="${name}"]`).forEach((input) => {
      if (input.value === value) input.checked = checked;
    });
  };

  if (typeMap[typeParam]) setFilterChecked('type', typeMap[typeParam], true);
  if (purposeParam) setFilterChecked('purpose', purposeParam, true);
  if (sortParam && sort) {
    if ([...sort.options].some((option) => option.value === sortParam)) {
      sort.value = sortParam;
    }
  }

  const getFilterValues = (name) => [
    ...new Set(
      [...document.querySelectorAll(`[data-filter="${name}"]:checked`)].map((input) => input.value)
    ),
  ];

  const applyShopFilters = () => {
    const type = getFilterValues('type');
    const format = getFilterValues('format');
    const recipient = getFilterValues('recipient');
    const purpose = getFilterValues('purpose');
    const personalized = getFilterValues('personalized');
    const price = getFilterValues('price');

    let items = [...cards];

    if (type.length) items = items.filter((card) => type.includes(card.dataset.type));
    if (format.length) items = items.filter((card) => format.includes(card.dataset.format));
    if (recipient.length) items = items.filter((card) => recipient.includes(card.dataset.recipient));
    if (purpose.length) items = items.filter((card) => purpose.includes(card.dataset.purpose));
    if (personalized.length) {
      items = items.filter((card) => personalized.includes(card.dataset.personalized));
    }
    if (price.length) {
      items = items.filter((card) => {
        const amount = Number(card.dataset.price || 0);
        return price.some((range) => {
          if (range === 'under-15') return amount < 1500;
          if (range === '15-35') return amount >= 1500 && amount <= 3500;
          return amount > 3500;
        });
      });
    }

    if (sort?.value === 'price-low') {
      items.sort((a, b) => Number(a.dataset.price || 0) - Number(b.dataset.price || 0));
    } else if (sort?.value === 'price-high') {
      items.sort((a, b) => Number(b.dataset.price || 0) - Number(a.dataset.price || 0));
    } else if (sort?.value === 'name') {
      items.sort((a, b) => (a.dataset.name || '').localeCompare(b.dataset.name || ''));
    } else if (sort?.value === 'new') {
      items.sort((a, b) => Number(b.dataset.created || 0) - Number(a.dataset.created || 0));
    } else if (sort?.value === 'best') {
      items.sort((a, b) => {
        const aBest = a.dataset.bestseller === 'true' || /best|bestseller|best-seller/i.test(a.dataset.type || '');
        const bBest = b.dataset.bestseller === 'true' || /best|bestseller|best-seller/i.test(b.dataset.type || '');
        if (aBest === bBest) return Number(b.dataset.created || 0) - Number(a.dataset.created || 0);
        return aBest ? -1 : 1;
      });
    }

    cards.forEach((card) => {
      card.hidden = true;
    });

    const visible = showAll || pagination ? items : items.slice(0, initialVisible);
    visible.forEach((card, index) => {
      card.hidden = false;
      card.style.order = String(index);
      grid.appendChild(card);
    });

    if (empty) empty.hidden = items.length !== 0;
    if (pagination) {
      const filtersActive =
        type.length +
          format.length +
          recipient.length +
          purpose.length +
          personalized.length +
          price.length >
        0;
      pagination.hidden = filtersActive;
    }
    if (count) {
      count.textContent = `${items.length} ${items.length === 1 ? 'product' : 'products'}`;
    }
    if (loadMore) {
      // Load More only when there is no server pagination.
      loadMore.hidden = Boolean(pagination) || showAll || items.length <= initialVisible;
    }

    if (empty) grid.appendChild(empty);
  };

  document.querySelectorAll('[data-filter]').forEach((input) => {
    input.addEventListener('change', () => {
      const twins = [...document.querySelectorAll(`[data-filter="${input.dataset.filter}"]`)].filter(
        (candidate) => candidate.value === input.value
      );
      twins.forEach((twin) => {
        if (twin !== input) twin.checked = input.checked;
      });
      if (!pagination) showAll = false;
      applyShopFilters();
    });
  });

  sort?.addEventListener('change', () => {
    if (!pagination) showAll = false;
    applyShopFilters();
  });

  loadMore?.addEventListener('click', () => {
    showAll = true;
    applyShopFilters();
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-clear-filters]')) return;
    document.querySelectorAll('[data-filter]').forEach((input) => {
      input.checked = false;
    });
    if (!pagination) showAll = false;
    applyShopFilters();
  });

  const categoryLinks = document.querySelectorAll('.td-shop-categories-section .category-nav a');
  if (categoryLinks.length) {
    const currentQuery = window.location.search.replace(/^\?/, '');
    categoryLinks.forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        const linkQuery = url.search.replace(/^\?/, '');
        const samePath = url.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');
        const isActive = samePath && linkQuery === currentQuery;
        if (isActive) link.setAttribute('aria-current', 'page');
        else if (linkQuery || currentQuery) link.removeAttribute('aria-current');
      } catch {
        /* ignore invalid urls */
      }
    });
  }

  applyShopFilters();
}

function initTdTestimonials() {
  document.querySelectorAll('[data-td-testimonials]').forEach((root) => {
    if (root.dataset.tdTestimonialsBound === 'true') return;
    root.dataset.tdTestimonialsBound = 'true';

    const track = root.querySelector('[data-testimonial-track]');
    const slides = [...root.querySelectorAll('[data-testimonial]')];
    const status = root.querySelector('[data-testimonial-status]');
    const prev = root.querySelector('[data-testimonial-prev]');
    const next = root.querySelector('[data-testimonial-next]');
    if (!track || slides.length < 2) return;

    let index = Math.max(
      0,
      slides.findIndex((slide) => slide.classList.contains('is-active'))
    );

    const isDesktop = () => window.matchMedia('(min-width: 768px)').matches;

    const show = (nextIndex) => {
      index = ((nextIndex % slides.length) + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const active = isDesktop() || slideIndex === index;
        slide.classList.toggle('is-active', slideIndex === index);
        slide.setAttribute('aria-hidden', String(!active));
      });

      if (status) {
        status.textContent = `Testimonial ${index + 1} of ${slides.length}`;
      }
    };

    prev?.addEventListener('click', () => show(index - 1));
    next?.addEventListener('click', () => show(index + 1));
    window.addEventListener('resize', () => show(index), { passive: true });
    show(index);
  });
}
